import React, {Fragment} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";

import Button from "@mui/material/Button";
import SvgIcon from "@mui/material/SvgIcon";
import CircularProgress from "@mui/material/CircularProgress";

import {featureInterface} from "../../../../../interfaces/featureInterface";
import {
  setLookActiveCategory, setLookActiveFeature,
  setLookMoreInfoOpened, setLookOpened, setLookOverlayOpened,
  setLookPageOpened
} from "../../../../../actions/lookFunctions";
import MaterialSpinner from "../../../../ui/materialSpinner";
import {removeFromCart, setCanvasScale, updateCanvasCount} from "../../../../../actions/actionFunctions";
import {checkIfFeatureDisabled, zoomCanvasOut} from "../../../lookNavigation/lookFunctions";
import {getFeatureGroupName, getFeatureIsLocked, isIframe} from "../../../../../misc/helpers";
import {
  getBundledFeatures,
  getCartItemsArrayFromFeature,
  getFeatureUrl,
  hideFeatureSection,
  isInStock
} from "../../../lookNavigation/lookFunctions2";
import WithUpdateLookCartItem from "../../../hocs/withUpdateLookCartItem";
import {
  setShowAddedToTheCartSuccess,
  setGroheSimilarProductsOpened,
  setLastOpenedCategory,
  setGroheSimilarFeature
} from "../../../../../actions/groheFunctions";
import {ROUTES} from "../../../../../routes";
import {LookCartIcon} from "../../../../common/icons";
import WithAddToCartPostMessage from "../../../hocs/withAddToCartPostMessage";
import LookCanvasContext from "../../../lookCanvasContext";
import WithZoomToFeature from "../../../hocs/withZoomToFeature";
import {LOOK_OVERLAYS} from "../../../core/constants";
import {COLORS} from "../../../../../colorThemes";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {getCurrentLayout} from "../../../../appLayout";

const GroheFeatureButtons = (props) => {

  const {lookActiveFeature, intl, fabricatorData, lookActiveCategory, setLookActiveCategory, history,
    setGroheSimilarProductsOpened, setLookPageOpened, isMobile, showAddedToTheCartSuccess, removeFromCart,
    setShowAddedToTheCartSuccess, setLastOpenedCategory, lookCompatabilityAlert, cartItemEditFeature,
    setGroheSimilarFeature, qtActiveCategory, groheActiveFeatureQuantity, lookOverlayOpened, setLookOpened,
    setCanvasScale, setLookOverlayOpened, setLookActiveFeature} = props;

  if (!lookActiveFeature) {
    return <MaterialSpinner/>
    // return null
  }

  const parent = lookActiveFeature.getParent();
  const alreadyDisabled = checkIfFeatureDisabled(lookActiveFeature, parent);

  const addToCartGroheButtonClick = (updateLookCartItem, addToCartPostMessage, zoomToFeatureGroup) => {

    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureAddToCart + (lookActiveFeature.dbFeature.sku || lookActiveFeature.dbFeature.sharedFeatureName));

    const featureGroup = lookActiveFeature.getParent();
    featureGroup.confirmedChange = true;
    setLookActiveCategory("");
    // const urlPartId = lookActiveFeature.partId.replace(/_/gi, "-");
    if (cartItemEditFeature) {
      removeFromCart(cartItemEditFeature);
    }
    history.push(getFeatureUrl(lookActiveFeature));
    updateLookCartItem(lookActiveFeature, true);
    if (!isMobile) {
      zoomToFeatureGroup(lookActiveFeature.partId, lookActiveFeature, null, false);
    }

    //void setLookOverlayOpened
    //void LOOK_OVERLAYS
    if (isIframe() && fabricatorData.isLixil) { // useEffect after loading complete
      let postFeatures = getBundledFeatures(lookActiveFeature);
      postFeatures.push(lookActiveFeature);
      addToCartPostMessage(getCartItemsArrayFromFeature(lookActiveFeature, groheActiveFeatureQuantity, qtActiveCategory));
    } else {
      setGroheSimilarProductsOpened(true);
      setGroheSimilarFeature(lookActiveFeature);
      setShowAddedToTheCartSuccess(true);
    }
  };

  const continueShoppingButtonClick = (imageCanvas) => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureContinueShopping);
    setLookPageOpened(ROUTES.category);
    setLookActiveCategory("");
    setLookActiveFeature(null);
    setShowAddedToTheCartSuccess(false);
    zoomCanvasOut(imageCanvas, setCanvasScale);
  };

  const changeButtonClick = (zoomToFeatureGroup, imageCanvas) => {
    if (lookActiveCategory) {
      Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureCloseProductsList);
      setLookActiveCategory("");
      setLastOpenedCategory("");
      const layout = getCurrentLayout();
      const noFeatureSection = hideFeatureSection(true, lookActiveCategory, lookActiveFeature, lookCompatabilityAlert);
      if (layout.partIdExistInQtCategory(lookActiveFeature.partId) && !noFeatureSection) {
        zoomToFeatureGroup(lookActiveFeature.partId, lookActiveFeature, null, false);
        history.push(getFeatureUrl(lookActiveFeature));
      } else {
        zoomCanvasOut(imageCanvas, setCanvasScale);
        setLookOpened(false);
        history.push(ROUTES.home);
      }
      return false
    }

    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureChange);
    if (showAddedToTheCartSuccess) {
      setShowAddedToTheCartSuccess(false);
    }
    setLookActiveCategory(lookActiveFeature.partId);
    zoomToFeatureGroup(lookActiveFeature.partId, lookActiveFeature, null, false);
    history.push(getFeatureUrl(lookActiveFeature, true));
  };

  const mobileMainButtonClick = (updateLookCartItem, addToCartPostMessage, zoomToFeatureGroup, imageCanvas) => {
    if (showAddedToTheCartSuccess) {
      continueShoppingButtonClick(imageCanvas)
      return
    }
    featureIsLocked
      ? lockedButtonClick()
      : addToCartGroheButtonClick(updateLookCartItem, addToCartPostMessage, zoomToFeatureGroup)
  }

  const isLoading = lookOverlayOpened === LOOK_OVERLAYS.loadingCart;
  const featureIsLocked = getFeatureIsLocked(lookActiveFeature);
  const disabled = isLoading || (!featureIsLocked && !isInStock(lookActiveFeature)); // todo quantity || isInStock(lookActiveFeature);

  const lockedButtonClick = () => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeatureUnlockNow);
    setLookOverlayOpened(LOOK_OVERLAYS.leadCapture);
  }

  const addToCartButtonTextId = isLoading
    ? isMobile ? "grohe.mobile.feature.loading" : "grohe.feature.addToCartButtonLoading"
    : featureIsLocked ? "grohe.feature.unlockProductButton"
      : cartItemEditFeature
        ? "quotingTool.footer.updateCartButton"
        : "grohe.feature.addToCartButton";

  const mobileMainButtonContent = () => {
    if (showAddedToTheCartSuccess) {
      return <FormattedMessage id="grohe.feature.continiueShopping"/>
    }
    return <FormattedMessage id={addToCartButtonTextId}/>
  }

  if (isMobile) {
    return (
      <LookCanvasContext.Consumer>
        {(imageCanvas) => (
          <WithZoomToFeature imageCanvas={imageCanvas}>
            {(zoomToFeatureGroup) => (
              <Fragment>
                <WithUpdateLookCartItem>
                  {(updateLookCartItem) => (
                    <WithAddToCartPostMessage>
                      {(addToCartPostMessage) => lookActiveCategory ? null : (
                        <Button className={"look-button look-button--secondary look-button--no-radius look-button--no-padding look-button--grohe-active"
                          + (isLoading ? " grohe-look__button--loading" : "")}
                                variant="outlined"
                                disabled={disabled}
                                startIcon={featureIsLocked || showAddedToTheCartSuccess ? null :
                                  isLoading
                                    ? <CircularProgress className="grohe-look__button-loader" style={{'color': COLORS.white}}/>
                                    : <SvgIcon><LookCartIcon /></SvgIcon>
                                }
                                onClick={() => mobileMainButtonClick(updateLookCartItem, addToCartPostMessage, zoomToFeatureGroup, imageCanvas)}>
                          {mobileMainButtonContent()}
                        </Button>
                      )}
                    </WithAddToCartPostMessage>
                  )}
                </WithUpdateLookCartItem>
                <Button className={"look-button look-button--secondary look-button--no-radius look-button--no-padding"
                + (lookActiveCategory ? " look-button--grohe-active" : "")}
                        variant="outlined" onClick={() => changeButtonClick(zoomToFeatureGroup, imageCanvas)}>
                  <FormattedMessage id={lookActiveCategory ? "look.feature.select" : "look.feature.change"}/>
                  {lookActiveCategory ? null : " " + getFeatureGroupName(parent, intl, fabricatorData)}
                </Button>
              </Fragment>
            )}
          </WithZoomToFeature>
        )}
      </LookCanvasContext.Consumer>
    )
  }

  return (
    <LookCanvasContext.Consumer>
      {(imageCanvas) => (
        <WithZoomToFeature imageCanvas={imageCanvas}>
          {(zoomToFeatureGroup) => (
            <div className="lk-feature__buttons grohe-buttons">
              <div className="lk-button grohe-lk__button">
                {showAddedToTheCartSuccess ? (
                  <Button className={"look-button look-button--primary grohe-look__button "}
                          onClick={() => continueShoppingButtonClick(imageCanvas)}>
                    <FormattedMessage id={"grohe.feature.continiueShopping"}/>
                  </Button>
                ) : !fabricatorData.settings.checkout ? null : (
                  <WithUpdateLookCartItem>
                    {(updateLookCartItem) => (
                      <WithAddToCartPostMessage>
                        {(addToCartPostMessage) => (
                          <Button className={"look-button look-button--primary grohe-look__button" + (isLoading ? " grohe-look__button--loading" : "")}
                                  disabled={disabled}
                                  startIcon={isLoading
                                    ? <CircularProgress className="grohe-look__button-loader" style={{'color': COLORS.white}}/>
                                    : featureIsLocked ? null : <SvgIcon><LookCartIcon /></SvgIcon>
                                  }
                                  onClick={() => featureIsLocked
                                    ? lockedButtonClick()
                                    : addToCartGroheButtonClick(updateLookCartItem, addToCartPostMessage, zoomToFeatureGroup)}>
                            <FormattedMessage id={addToCartButtonTextId}/>
                          </Button>
                        )}
                      </WithAddToCartPostMessage>
                    )}
                  </WithUpdateLookCartItem>
                )}
              </div>
              <div className="lk-button grohe-lk__button">
                <Button className={"look-button grohe-look__button look-button--bg" + (lookActiveCategory ? " look-button--tertiary" : " look-button--primary")}
                        disabled={alreadyDisabled}
                        onClick={() => changeButtonClick(zoomToFeatureGroup)}>
                  <FormattedMessage id={lookActiveCategory ? "grohe.feature.closeMenu" : "look.feature.change"}/>
                  {lookActiveCategory ? null : " " + getFeatureGroupName(parent, intl, fabricatorData)}
                </Button>
              </div>
            </div>
          )}
        </WithZoomToFeature>
      )}
    </LookCanvasContext.Consumer>
  )
};

GroheFeatureButtons.propTypes = {
  lookFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store) => {
  const {lookActiveFeature, lookActiveCategory, lookOverlayOpened, lookCompatabilityAlert} = store.lookState;
  const {isMobile} = store.serverState;
  const {showAddedToTheCartSuccess, groheActiveFeatureQuantity} = store.groheState;
  const {qtActiveCategory} = store.qtState;
  const {isPhoneNumberValidated} = store.userState; // to update component when user is logged in
  const {cartItemEditFeature} = store.cartState;

  return {
    lookActiveFeature,
    lookActiveCategory,
    fabricatorData: store.fabricatorState,
    isMobile,
    showAddedToTheCartSuccess,
    qtActiveCategory,
    groheActiveFeatureQuantity,
    lookOverlayOpened,
    isPhoneNumberValidated,
    lookCompatabilityAlert,
    cartItemEditFeature,
  };
};

const mapDispatchToProps = {
  setLookActiveCategory,
  setLookMoreInfoOpened,
  updateCanvasCount,
  setGroheSimilarProductsOpened,
  setLookPageOpened,
  setLastOpenedCategory,
  setCanvasScale,
  setShowAddedToTheCartSuccess,
  setGroheSimilarFeature,
  setLookOpened,
  setLookOverlayOpened,
  removeFromCart,
  setLookActiveFeature,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(GroheFeatureButtons)
  )
)
